export const FULFILLMENT_TIMELINE_STEPS = [
  { key: 'pending', label: 'Pendiente', icon: 'fa-clock' },
  { key: 'processing', label: 'En preparación', icon: 'fa-box-open' },
  { key: 'shipped', label: 'Despachado', icon: 'fa-truck' },
  { key: 'in_transit', label: 'En camino', icon: 'fa-location-arrow' },
  { key: 'delivered', label: 'Entregado', icon: 'fa-check-circle' },
];

export const TERMINAL_TIMELINE_STEPS = [
  { key: 'cancelled', label: 'Cancelado', icon: 'fa-times-circle' },
  { key: 'failed', label: 'Envío fallido', icon: 'fa-exclamation-triangle' },
];

const SHIPPING_STATUS_CODES = {
  paid_pending_shipment: 'pending',
  preparing: 'processing',
  handed_to_carrier: 'shipped',
  in_transit: 'in_transit',
  delivered: 'delivered',
  failed: 'failed',
  cancelled: 'cancelled',
};

const DISPLAY_LABELS = {
  paid_pending_shipment: 'Pendiente de envío',
  preparing: 'En preparación',
  handed_to_carrier: 'Despachado',
  in_transit: 'En camino',
  delivered: 'Entregado',
  failed: 'Envío fallido',
  cancelled: 'Cancelado',
};

export function mapShippingStatusToStepKey(shippingStatus) {
  const code = String(shippingStatus || '').toLowerCase();
  if (SHIPPING_STATUS_CODES[code]) {
    return SHIPPING_STATUS_CODES[code];
  }
  return 'pending';
}

export function mapFulfillmentToStepKey(status) {
  const s = String(status || '').toLowerCase();
  if (s.includes('cancelado')) return 'cancelled';
  if (s.includes('fallido') || s.includes('failed')) return 'failed';
  if (s.includes('entregado') || s.includes('recibido')) return 'delivered';
  if (s.includes('camino') || s.includes('tránsito') || s.includes('transito')) return 'in_transit';
  if (s.includes('despachado') || s.includes('enviado')) return 'shipped';
  if (s.includes('tomando') || s.includes('preparando')) return 'processing';
  return 'pending';
}

export function resolveTimelineStepKey({ shippingStatus, fulfillmentStatus }) {
  if (shippingStatus) {
    return mapShippingStatusToStepKey(shippingStatus);
  }
  return mapFulfillmentToStepKey(fulfillmentStatus);
}

export function getTimelineStepIndex(stepKey) {
  const idx = FULFILLMENT_TIMELINE_STEPS.findIndex((s) => s.key === stepKey);
  if (idx >= 0) return idx;
  return -1;
}

export function isTerminalTimelineStep(stepKey) {
  return stepKey === 'cancelled' || stepKey === 'failed';
}

export function resolveTimelineDisplayStep(stepKey) {
  if (isTerminalTimelineStep(stepKey)) {
    return TERMINAL_TIMELINE_STEPS.find((s) => s.key === stepKey) || null;
  }
  return FULFILLMENT_TIMELINE_STEPS.find((s) => s.key === stepKey) || FULFILLMENT_TIMELINE_STEPS[0];
}

export function shippingStatusToDisplayLabel(shippingStatus) {
  const code = String(shippingStatus || '').toLowerCase();
  if (DISPLAY_LABELS[code]) {
    return DISPLAY_LABELS[code];
  }
  const step = resolveTimelineDisplayStep(mapShippingStatusToStepKey(shippingStatus));
  return step?.label || 'Pendiente';
}
